import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { getStylesMode } from 'ziphy-web-shared/basic/helpers';
import styles from './TextWithDash.module.scss';
const TextWithDash = ({ mode = 'gray', children, className }) => {
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, getStylesMode(mode, styles), className) }, { children: [_jsx("div", { className: styles.left }), _jsx("div", Object.assign({ className: styles.text }, { children: children })), _jsx("div", { className: styles.right })] })));
};
export default TextWithDash;
